module.exports = __webpack_public_path__ + "img/headshot-cgarcia.0d6b6a12.png";